export default ({ request }) => ({
  orderGoodsNotbatchListApi(data = {}) {
    return request({
      url: '/factory/order/goods/notbatch/list',
      method: 'post',
      data,
    })
  },
})
